import { Show, useForm } from "@refinedev/antd";
import { useNavigation } from "@refinedev/core";
import {
  Button,
  Checkbox,
  Col,
  Form,
  Input,
  InputNumber,
  Row,
  Select,
  Switch,
} from "antd";
import { useMatch } from "react-router-dom";

import { AppTitle } from "../../../components";
import {
  SLUG_PATTERN,
  TV_SHOW_KIND_LABELS,
  TvShow,
  toOptions,
  tvErrorNotification,
  tvSuccessNotification,
} from "../Lib";
import { MatchesEditor, TvDelete, TvImageField } from "../Components";

export const TvShowShow = () => {
  const route = useMatch("/tv/shows/:id");
  const id = Number(route?.params.id) || undefined;
  const { push } = useNavigation();

  const { formProps, queryResult, formLoading } = useForm<TvShow>({
    resource: "tv-shows",
    dataProviderName: "tvDataProvider",
    action: id ? "edit" : "create",
    id,
    redirect: false,
    ...tvSuccessNotification(id ? "Шоу сохранено" : "Шоу добавлено"),
    ...tvErrorNotification(),
    onMutationSuccess: ({ data }) => {
      if (!id && data?.id) push(`/tv/shows/${data.id}`);
    },
  });
  const record = queryResult?.data?.data;
  const kind = Form.useWatch("kind", formProps.form);

  return (
    <Show
      isLoading={formLoading}
      title={
        <AppTitle isLoading={formLoading} canGoBack>
          {id ? record?.title ?? "Шоу" : "Новое шоу"}
        </AppTitle>
      }
      breadcrumb={false}
      goBack={false}
      footerButtons={null}
      headerButtons={() =>
        id && record ? (
          <TvDelete
            resource="tv-shows"
            id={id}
            name={record.title}
            entityAccusative="шоу"
            redirectPath="/tv/shows"
            size="middle"
          />
        ) : null
      }
    >
      <Form
        {...formProps}
        layout="vertical"
        initialValues={
          id
            ? formProps.initialValues
            : {
                kind: "ORIGINS",
                inHeader: false,
                isActive: true,
                sortOrder: 0,
                coverFull: false,
              }
        }
      >
        <Row gutter={32}>
          <Col xs={24} xl={14}>
            <Form.Item name="kind" label="Вид" rules={[{ required: true }]}>
              <Select options={toOptions(TV_SHOW_KIND_LABELS)} />
            </Form.Item>
            <Form.Item
              name="title"
              label="Название"
              rules={[{ required: true, whitespace: true }, { max: 255 }]}
            >
              <Input />
            </Form.Item>
            <Form.Item
              name="slug"
              label="Адрес страницы"
              extra="Латиница, цифры и дефис: tv.fnl.pro/show/my-hotim-igrat"
              rules={[
                { required: true, message: "Укажите адрес" },
                {
                  pattern: SLUG_PATTERN,
                  message:
                    "Только латиница, цифры и дефис, от 2 до 128 символов",
                },
              ]}
            >
              <Input addonBefore="/show/" />
            </Form.Item>
            <Form.Item name="description" label="Описание">
              <Input.TextArea autoSize={{ minRows: 3, maxRows: 8 }} />
            </Form.Item>
            {kind === "SPECIAL" && (
              <Form.Item
                name="matches"
                label="Матчи"
                extra="Встанут в ленту спецпроекта вместе с выпусками — по дате, новые сверху"
              >
                <MatchesEditor />
              </Form.Item>
            )}
            <Row gutter={16}>
              <Col span={8}>
                <Form.Item
                  name="sortOrder"
                  label="Порядок"
                  extra="Меньше — выше"
                >
                  <InputNumber style={{ width: "100%" }} />
                </Form.Item>
              </Col>
              <Col span={8}>
                <Form.Item
                  name="isActive"
                  label="Показывать"
                  valuePropName="checked"
                >
                  <Switch />
                </Form.Item>
              </Col>
            </Row>
          </Col>
          <Col xs={24} xl={10}>
            <Form.Item name="coverUrl" label="Обложка">
              <TvImageField />
            </Form.Item>
            <Form.Item
              name="coverFull"
              valuePropName="checked"
              extra="Обложка ляжет фоном на всю шапку страницы, название и кнопки — поверх слева. Макет 2560×640: по краям и слева — только фон, всё важное справа от центра (примерно 1200–2050 px по ширине и 100–540 px по высоте). Без галочки — обложка в окне 16:9 рядом с названием"
            >
              <Checkbox>Обложка на всю шапку</Checkbox>
            </Form.Item>
            <Form.Item name="logoUrl" label="Логотип">
              <TvImageField label="Логотип" />
            </Form.Item>
          </Col>
        </Row>
        <Button type="primary" htmlType="submit" loading={formLoading}>
          {id ? "Сохранить" : "Добавить шоу"}
        </Button>
      </Form>
    </Show>
  );
};
